import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IFSM } from '../../../stores/model/metamodel/fsm';

/**
 * Check for forward inaccessible states in an FSM
 */
class FSMForwardInaccessibilityCheck extends Check<IFSM> {
  static description = 'Check forward inaccessibility';

  check(): Report {
    this.report = new Report();

    const inaccessible = this.element.forwardInaccessibleStates;
    if (inaccessible.length === 0) {
      this.report.addMessage(
        MessageType.INFORMATION,
        `No forward inaccessible states found.`,
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.WARNING,
        `Forward inaccessible states found: ${inaccessible.map(s => s.name).join(', ')}.`,
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default FSMForwardInaccessibilityCheck;
